export default __webpack_public_path__ + "static/media/trash.ee650a65.svg";